module.exports = __webpack_public_path__ + "static/media/cleany-snacks-and-drinks.136c489c.jpg";